import { ACTIVE_EXPERIMENTS, EXPERIMENT_KEYS } from '$lib/services/experiments/client/constants';
import { experimentService } from '$lib/services/experiments/client';
import { ProductExperienceService } from '$lib/services/product-experience';
import { AOFL_PRODUCT_NAMES } from '$lib/utils/constants';
import { get } from 'svelte/store';
import { app } from '$lib/stores/app/store';

/**
 *  @type {{[key: string]: import('$lib/utils/page').PageCondition}} conditions - The conditions object containing the conditions to be resolved.
 */
const pageConditions = {
	// In-app users should always be shown the in-app experience (and it should be the 1.0 version)
	inApp: {
		condition: async (config) => {
			return config.meta.inApp;
		},
		resolve: async () => {
			await ProductExperienceService.setProductExperience(AOFL_PRODUCT_NAMES.ABCMOUSE);
			return await import('../_in-app/Page.svelte');
		},
	},
	browser_2_0_rebrand_direct_annual_price_a: {
		condition: async () => {
			const appMeta = get(app)?.meta ?? {};
			const isUsEn = appMeta.viewerCountry === 'US' && appMeta.localeCode === 'en-US';
			if (!isUsEn) return false;

			await experimentService.initializeExperiments([
				...EXPERIMENT_KEYS,
				ACTIVE_EXPERIMENTS.ABCM2_DIRECT_ANNUAL_PRICE.experimentKey,
			]);

			const assignedVariant = await experimentService.getExperimentArm(
				ACTIVE_EXPERIMENTS.ABCM2_DIRECT_ANNUAL_PRICE.experimentKey,
				{
					page_name: 'home',
					page_url: '/abc/home',
				}
			);

			return assignedVariant === ACTIVE_EXPERIMENTS.ABCM2_DIRECT_ANNUAL_PRICE.variants.test_a;
		},
		resolve: async () => await import('../_browser-2-0-rebrand-direct-annual-price-a/Page.svelte'),
	},
	browser_2_0_rebrand_direct_annual_price_b: {
		condition: async () => {
			const appMeta = get(app)?.meta ?? {};
			const isUsEn = appMeta.viewerCountry === 'US' && appMeta.localeCode === 'en-US';
			if (!isUsEn) return false;

			await experimentService.initializeExperiments([
				...EXPERIMENT_KEYS,
				ACTIVE_EXPERIMENTS.ABCM2_DIRECT_ANNUAL_PRICE.experimentKey,
			]);

			const assignedVariant = await experimentService.getExperimentArm(
				ACTIVE_EXPERIMENTS.ABCM2_DIRECT_ANNUAL_PRICE.experimentKey,
				{
					page_name: 'home',
					page_url: '/abc/home',
				}
			);

			return assignedVariant === ACTIVE_EXPERIMENTS.ABCM2_DIRECT_ANNUAL_PRICE.variants.test_b;
		},
		resolve: async () => await import('../_browser-2-0-rebrand-direct-annual-price-b/Page.svelte'),
	},
	browser_2_0_rebrand_direct_annual_price_c: {
		condition: async () => {
			const appMeta = get(app)?.meta ?? {};
			const isUsEn = appMeta.viewerCountry === 'US' && appMeta.localeCode === 'en-US';
			if (!isUsEn) return false;

			await experimentService.initializeExperiments([
				...EXPERIMENT_KEYS,
				ACTIVE_EXPERIMENTS.ABCM2_DIRECT_ANNUAL_PRICE.experimentKey,
			]);

			const assignedVariant = await experimentService.getExperimentArm(
				ACTIVE_EXPERIMENTS.ABCM2_DIRECT_ANNUAL_PRICE.experimentKey,
				{
					page_name: 'home',
					page_url: '/abc/home',
				}
			);

			return assignedVariant === ACTIVE_EXPERIMENTS.ABCM2_DIRECT_ANNUAL_PRICE.variants.test_c;
		},
		resolve: async () => await import('../_browser-2-0-rebrand-direct-annual-price-c/Page.svelte'),
	},
	default: {
		condition: async () => true,
		resolve: async () => {
			await experimentService.initializeExperiments([...EXPERIMENT_KEYS]);

			return await import('../_browser-2-0-rebrand/Page.svelte');
		},
	},
};

export { pageConditions };
